"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreStoredTextClient = void 0;
const tslib_1 = require("tslib");
const crud_client_1 = require("./crud.client");
class PreStoredTextClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'prestored-text';
    }
    getLinkedEntities(projectId, ids, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`${this.getPath(projectId)}/linked-entities?${this.getQueryString({
                fields,
                ids,
            })}`);
            return response.payload;
        });
    }
}
exports.PreStoredTextClient = PreStoredTextClient;
//# sourceMappingURL=prestored-text.client.js.map